import React from 'react'
import {CardBody, Form, FormGroup, Input, Label, Modal} from "reactstrap";

const render_rows = (tog_standard, modal_standard, new_brand_name_ref, createBrand) => {

    return (
        <Modal isOpen={modal_standard}
               toggle={tog_standard}
        >
            <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                    Nueva Marca
                </h5>
                <button type="button"
                        onClick={tog_standard}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <CardBody>
                    <Form>
                        <FormGroup>
                            <Label htmlFor="bundle_qty">Nombre</Label>
                            <Input autoComplete="off" id="new_brand_name" name="new_brand_name" type="text" className="form-control" innerRef={new_brand_name_ref} />
                        </FormGroup>
                    </Form>
                </CardBody>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    onClick={tog_standard}
                    className="btn btn-secondary waves-effect"
                    data-dismiss="modal"
                >
                    No
                </button>
                <button
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ backgroundColor: 'rgb(174,174,174)', borderColor: 'rgb(177,177,177)'  }}
                    onClick={() => createBrand()}
                >
                    Crear
                </button>
            </div>
        </Modal>
    );
}

const ModalCreate = ({tog_standard, modal_standard, new_brand_name_ref, createBrand}) => (
    render_rows(tog_standard, modal_standard, new_brand_name_ref, createBrand)
)

export default ModalCreate
